import axios from 'axios';
import store from '../store'
import verifyAuth from '../services/utilities'

class TournamentRepository {

    constructor() {
        this.basePath = store.state.backend;
    }

    getAllTournaments() {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournaments`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    getPublicTournaments() {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournaments/public`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    getAllTournamentParticipants(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournament-participants/all?tournamentId=${tournamentId}`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    getTournamentsByClubId(clubId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournaments/club?clubId=${clubId}`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    findParticipantByTournament(tournamentId, userId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournament-participants?tournamentId=${tournamentId}&userId=${userId}`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    enrollParticipant(tournamentParticipant) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.post(`${this.basePath}/ext/tournament-participants`, tournamentParticipant, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    getTournamentOverview(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournaments/overview/${tournamentId}`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    getTournamentOverviewAdmin(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournaments/${tournamentId}/overview/admin`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    getTournamentOverviewOpen(tournamentId, identifier, page = 0, size = 5000) {
        // Server-side pagination support
        // Default size=5000 to fetch all participants for most tournaments
        // Table.vue handles client-side pagination for display (10 per page)
        // For tournaments with >5000 participants, increase this value or implement true server-side pagination
        let url = identifier
            ? `${this.basePath}/ext/tournaments/overview-open/${tournamentId}/${identifier}?page=${page}&size=${size}`
            : `${this.basePath}/ext/tournaments/overview-open/${tournamentId}?page=${page}&size=${size}`;
        let response = axios.get(url);
        response = verifyAuth(response)
        return response;
    }

    createFullTournament(fullTournament) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.post(`${this.basePath}/ext/tournaments/create-full`, fullTournament, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    createFullTournamentSettings(fullTournamentSettings) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.post(`${this.basePath}/ext/tournamentSettings/tournaments/create-full/tournamentSettings`, fullTournamentSettings, { headers: headers });
        response = verifyAuth(response)
        return response;
    }


    editFullTournament(tournamentEditData) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/ext/tournaments/edit-full`, tournamentEditData, { headers: headers });
        response = verifyAuth(response)
        return response;
    }
    editTournamentBasics(basicsData) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/brokers/tournament/admin/edit-basics`, basicsData, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    editTournamentPrizes(prizesData) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/brokers/tournament/admin/edit-prizes`, prizesData, { headers: headers });
        response = verifyAuth(response);
        return response;
    }
    updateTournamentImage(data) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/ext/tournaments/tournament-image/${data.tournamentId}`, data.formData, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    changeParticipantStatus(participantId, newStatus) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/ext/tournament-participants/status?participantId=${participantId}&newStatus=${newStatus}`, null, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    getTournamentsByUser(userId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/${userId}/tournaments`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    sendTournamentRequest(request) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.post(`${this.basePath}/ext/tournaments/request-creation`, request, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    updateParticipantBrokerAccount(participantId, brokerAccountId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/ext/tournament-participants/update-assigned-account?participantId=${participantId}&brokerAccountId=${brokerAccountId}`, null, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getTournamentRules(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournaments/rules/${tournamentId}`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getClubBrokers(clubId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournamentsettings/${clubId}/brokers`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getServerDetails(brokerId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/meta-trader-server-details/server-group/${brokerId}`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    // New methods for tournament archiving
    getArchivedTournaments() {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournamentSettings/archived`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getTournamentsByVisibility(visibilityType) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournamentSettings/visibility-types?visibility=${visibilityType}`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    archiveTournament(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/ext/tournamentSettings/${tournamentId}/visibility/ARCHIVED`, null, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    unarchiveTournament(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/ext/tournamentSettings/${tournamentId}/visibility/PRIVATE`, null, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getRankingRules(rankingType) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournamentSetting/${rankingType}`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    registerPublicTournament(payload) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.post(`${this.basePath}/process-woocommerce`, payload, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    updateTournamentState(tournamentId, state) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/ext/tournamentSettings/${tournamentId}/state/${state}`, {}, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    // New wizard endpoints
    getWizardConfiguration(clubId) {
        //eslint-disable-next-line no-console
        console.log('Getting wizard configuration for clubId:', clubId);
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        //eslint-disable-next-line no-console
        console.log('Getting wizard configuration with headers:', headers);
        let response = axios.get(`${this.basePath}/ext/tournaments/wizard?clubId=${clubId}`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getWizardRankings(clubId, platform, platformGroupId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken']};
        let url = `${this.basePath}/ext/tournaments/wizard/ranking?clubId=${clubId}&platform=${platform}`;
        if (platformGroupId !== null && platformGroupId !== undefined) {
            url += `&platformGroupId=${platformGroupId}`;
        }
        let response = axios.get(url, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getWizardRules(clubId, platform, platformGroupId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let url = `${this.basePath}/ext/tournaments/wizard/rules?clubId=${clubId}&platform=${platform}`;
        if (platformGroupId !== null && platformGroupId !== undefined) {
            url += `&platformGroupId=${platformGroupId}`;
        }
        let response = axios.get(url, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getParticipantAnalyticsMini(tournamentId, participantId, tournametStartDate, tournametEndDate ) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        const payload = {
            tournamentId: tournamentId,
            participantId: participantId,
            fromDate: tournametStartDate,
            toDate: tournametEndDate
        };
        let response = axios.post(`${this.basePath}/ext/tournaments/participants/analytics/mini?page=0&size=1`, payload, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getTournamentPrizePool(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournaments/${tournamentId}/prize-pool`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getTournamentBrackets(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/brokers/tournament/admin/tournaments/master/brackets/by-tournament/${tournamentId}`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }
    editTournamentRules(rulesData) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/brokers/tournament/admin/edit-rules`, rulesData, { headers: headers });
        response = verifyAuth(response);
        return response;
    }
    editTournamentBranding(brandingData) {
        let headers = { 
            'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken']
        };
        // Don't set Content-Type for FormData - axios will set it automatically with the correct boundary
        let response = axios.put(`${this.basePath}/brokers/tournament/admin/edit-branding`, brandingData, { headers: headers });
        response = verifyAuth(response);
        return response;
    }
    editTournamentBrandingBulk(tournamentId, brandingData) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        // OJO: no setear Content-Type para FormData
        let response = axios.put(`${this.basePath}/brokers/tournament/admin/tournaments/${tournamentId}/branding-bulk`, brandingData, { headers: headers });
        response = verifyAuth(response);
        return response;
    }
    getTournamentBrandingImage(imageKey) {
        let headers = { 
            'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken']
        };
        let response = axios.get(`${this.basePath}/brokers/tournament/admin/branding-image/${imageKey}`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }
    getTournamentBranding(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/brokers/tournament/admin/tournaments/${tournamentId}/branding`,{ headers });
        response = verifyAuth(response);
        return response;
}
    getAdminInfo(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/brokers/tournament/admin/tournaments/${tournamentId}/settings/admin-info`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }
    editTournamentRanking(rankingData) {
        let headers = { 
            'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken']
        };
        let response = axios.put(`${this.basePath}/brokers/tournament/admin/edit-ranking`, rankingData, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

}

export default new TournamentRepository();
